import { AccountWithDeviceRequest } from "./account-with-device-request";

export class SSOAccountWithDeviceRequest extends AccountWithDeviceRequest {
    public DeviceReferences: string[];
}